import {
  Button,
  createStyles,
  stylize,
  Theme,
  WithStyles,
} from "@envestnet/envreact-component-library";
import classNames from "classnames";
import CentricLayout from "components/CentricLayout";
import Logo from "images/Logo";
import React, { CSSProperties } from "react";
import { defineMessages } from "utils/defineMessages";
import withIntl from "utils/withIntl";

const scope = "app.containers.SignoutPage";

const messages = defineMessages(scope, {
  signOutText: "You have been successfully logged out.",
  logIn: "Log In",
});

const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.colors.background,
      height: "100vh",
    },
    bodyText: {
      fontFamily:
        "Red Hat Display, Lato, Helvetica Neue, Helvetica, Arial, sans-serif !important",
      fontSize: "24px",
      color: theme.colors.textSubtle,
      marginTop: "24px",
    },
    loginButton: {
      borderRadius: 0,
      marginTop: "64px",
    },
  });

type DefaultProps = {};

export type Props = DefaultProps & {
  className?: string;
  style?: CSSProperties;
};

const defaultProps: DefaultProps = {};

const SignOutActual = ({
  classes,
  className,
  style,
  formatMessage,
}: Props & WithStyles<typeof styles> & { formatMessage: FormatMessage }) => (
  <div className={classNames(classes.root, className)} style={style}>
    <CentricLayout>
      <>
        <Logo />
        <div className={classes.bodyText}>
          {formatMessage(messages.signOutText)}
        </div>
        <Button
          name={formatMessage(messages.logIn)}
          className={classes.loginButton}
          onClick={() => {
            window.location.replace(window.location.origin);
          }}
        />
      </>
    </CentricLayout>
  </div>
);

SignOutActual.defaultProps = defaultProps;

export const SignoutPage = withIntl(
  stylize<Props, DefaultProps>(styles)(SignOutActual)
);
